import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Parking } from 'src/features/parkingManagement/types/parking.ts';
import type { GeneralSmartParkError } from 'src/types';

type DisableBoricaPaymentsFnType = typeof disableBoricaPayments;

export type DisableBoricaPaymentsDTO = {
    parkingId: string;
};

const disableBoricaPayments = ({ parkingId, ...data }: DisableBoricaPaymentsDTO): Promise<Parking> => {
    return axios.post(formatResourcePath(`/parkings/:parkingId/disable-borica-payments/`, { parkingId }), data);
};

interface UseMutationOptions extends MutationConfig<DisableBoricaPaymentsFnType, GeneralSmartParkError> {}

export const useDisableBoricaPayments = (options: UseMutationOptions) =>
    useMutation({
        mutationFn: disableBoricaPayments,
        ...options,
    });
